<template>
  <div class="kiw-create">
    <app-view-layout header="Nowy wniosek KIW">
      <template #content>
        <v-form
          ref="createKIWForm"
          v-model="isFormValid"
          @submit.prevent="submit"
        >
          <KIWFormCard
            v-model="kiw"
            class="mt-4 mb-8"
          />

          <TemplateSelected
            v-if="fromArchive"
            :id="id"
            type="Project"
          />

          <AppTextCard
            v-model="kiw.notes"
            class="mb-8"
            title="Komentarz"
          />

          <ProjectFilesCard
            ref="graphicFiles"
            :files="files"
            hide-tabs
            disable-download
            :processing="isProcessing"
            @add="showFileAddDialog"
            @delete="deleteFiles"
          />

          <v-btn
            class="my-8"
            color="primary"
            type="submit"
            height="40"
            max-width="120"
            :loading="isProcessing"
          >
            Wyślij wniosek
          </v-btn>
        </v-form>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import KIWFormCard from '@/components/KIW/KIWFormCard.vue';
import AppTextCard from '@/components/UI/AppTextCard.vue';
import ProjectFilesCard from '@/components/Projects/ProjectFilesCard.vue';
import TemplateSelected from '@/components/Projects/TemplateSelected.vue';

export default {
  components: {
    AppViewLayout,
    KIWFormCard,
    AppTextCard,
    ProjectFilesCard,
    TemplateSelected,
  },

  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    fromArchive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      rules: validationRules,
      isFormValid: true,
      isTemplateSelectionValid: true,
      kiw: {
        name: '',
        departmentId: '',
        purpose: '',
        customPurpose: '',
        projectId: null,
        embargo: null,
        notes: '',
      },
    };
  },

  computed: {
    ...mapState('kiwSingle', [
      'draft',
      'isProcessing',
    ]),
    ...mapState('files', [
      'files',
    ]),
  },

  created() {
    if (this.fromArchive) {
      this.kiw.projectId = this.id;
    }
  },

  beforeDestroy() {
    this.changeProcessingStatus(false);
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === 'archive-project-single') {
        vm.getDraftData();
      }
    });
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === 'archive-project-single') {
      this.saveDraft(this.kiw);
    } else {
      this.deleteDraft();
      this.clearTempFiles();
    }
    next();
  },

  methods: {
    ...mapActions('kiwSingle', [
      'createSingleKIW',
      'changeProcessingStatus',
      'saveDraft',
      'deleteDraft',
    ]),
    ...mapActions('files', [
      'deleteTempFiles',
      'clearTempFiles',
    ]),
    ...mapActions('dialog', [
      'showDialog',
    ]),
    ...mapActions('snackbar', [
      'showSnackbar',
    ]),

    getDraftData() {
      if (this.draft) this.kiw = this.draft;
    },

    submit() {
      this.$refs.createKIWForm.validate();

      if (this.isFormValid) {
        this.createSingleKIW({
          ...this.kiw,
          files: this.files.map((el) => el.data),
        });
      } else {
        this.$vuetify.goTo(0);
        this.showSnackbar({
          message: ['Występują błędy/braki w formularzu'],
          type: 'error',
        });
      }
    },

    showFileAddDialog() {
      this.showDialog({
        header: 'Dodawanie pliku',
        text: 'Wybierz plik i dodaj do projektu.',
        component: 'FileAdd',
      });
    },

    deleteFiles(fileIds) {
      this.deleteTempFiles(fileIds);
      this.$refs.graphicFiles.clearSelection();
    },
  },
};
</script>
